import { render, staticRenderFns } from "./showAllSponsorsEdition.vue?vue&type=template&id=a6109c86"
import script from "./showAllSponsorsEdition.vue?vue&type=script&lang=js"
export * from "./showAllSponsorsEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports